import i18n from 'i18next'
import ICU from 'i18next-icu'
import { initReactI18next } from 'react-i18next'

i18n
  .use(initReactI18next)
  .use(ICU)
  .init({
    load: 'languageOnly', // we only provide en, de -> no region specific locals like en-US, de-DE
    // have a common namespace used around the full app
    ns: ['common', 'publisher'],
    defaultNS: 'publisher',
    debug: false,
  })

export default i18n
